import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchTenantMembers } from '@/api/tenants/tenantsApi';
import type { TenantMember } from '@/api/tenants/tenantsApi.types';
import { buildTenantMembersQueryKey } from '@/constants/queryKeys';

export function useTenantMembersQuery(tenantId: string): UseQueryResult<TenantMember[], Error> {
  return useQuery({
    queryKey: buildTenantMembersQueryKey(tenantId),
    queryFn: function loadMembers() {
      return fetchTenantMembers(tenantId);
    },
  });
}
